"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORSBus = void 0;
var string_template_1 = __importDefault(require("string-template"));
var consts_1 = require("./consts");
var bus_request_1 = require("./bus-request");
var bus_broadcast_1 = require("./bus-broadcast");
var inversify_1 = require("inversify");
var config_1 = require("./config");
var CORSBus = /** @class */ (function () {
    function CORSBus(config, request, broadcast) {
        this.config = config;
        this.request = request;
        this.broadcast = broadcast;
        this.await = new Promise(function () { });
    }
    /**
     * 初始化
     */
    CORSBus.prototype.init = function () {
        this.registBus();
    };
    /**
     * 注册bus
     */
    CORSBus.prototype.registBus = function () {
        var _this = this;
        if (this.config.cbusRootWindow === window) {
            this.busIdMap = new Map();
            this.request.regist(consts_1.REGIST_KEY, function (busId, event) {
                if (!_this.busIdMap)
                    return;
                if (_this.busIdMap.has(busId) && _this.busIdMap.get(busId) !== event.origin) {
                    console.error(new Error(string_template_1.default(consts_1.MESSAGE_BUS_CONFLICT, { id: busId })));
                    return false;
                }
                else {
                    _this.busIdMap.set(busId, event.origin);
                    return true;
                }
            });
        }
        this.await = this.request.action(consts_1.REGIST_KEY, this.config.id);
    };
    CORSBus = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [config_1.Config,
            bus_request_1.BusRequest,
            bus_broadcast_1.BusBroadCast])
    ], CORSBus);
    return CORSBus;
}());
exports.CORSBus = CORSBus;
//# sourceMappingURL=cors-bus.js.map